import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'purchasing',
    component: RouterView,
    children: [
      {
        path: '',
        component: () => import('./views/purchasing-index.vue'),
        meta: {
          layoutFeatures: {
            actionPanel: true,
          },
        },
      },
      {
        path: 'in-season-reaction',
        component: () => import('./views/purchasing-in-season-reaction.vue'),
        meta: {
          pageTitle: 'Purchasing • In Season Reaction',
          layoutFeatures: {
            actionPanel: true,
            pageControlsTarget: 'end',
          },
        },
      },
    ],
  },
];
export default routes;
